export default "__VITE_PUBLIC_ASSET__e0fd8c22__"